<template>
  <div class="challenge_content">
    <div class="content_header">
      <div class="header_select">
        <label>
          並び替え
          <select v-model="order">
            <option value="new">新しい</option>
            <option value="old">古い</option>
          </select>
        </label>
      </div>
    </div>
    <div class="content_list_wrapper">
      <ul class="content_list">
        <li class="item" v-for="(item, index) in posts" :key="index">
          <button @click="pickup(item, index)">
            <div class="item_main">
              <div class="item_header">
                <p class="index">
                  {{ order == "new" ? index + 1 : posts.length - index }}
                </p>
                <p class="date">
                  {{ timeTransfer(item.created.seconds * 1000) }}
                </p>
              </div>
              <p class="item_img">
                <img :src="item.images[0]" :alt="`${index}枚目`" />
              </p>
            </div>
            <div class="item_sub">
              <div class="pc">
                <p class="item_img">
                  <img
                    v-if="item.images[1]"
                    :src="item.images[1]"
                    :alt="`${index}枚目`"
                  />
                </p>
              </div>
              <div class="pc">
                <p class="item_img">
                  <img
                    v-if="item.images[2]"
                    :src="item.images[2]"
                    :alt="`${index}枚目`"
                  />
                </p>
              </div>
              <div class="pc">
                <p class="item_img">
                  <img
                    v-if="item.images[3]"
                    :src="item.images[3]"
                    :alt="`${index}枚目`"
                  />
                </p>
              </div>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import firebaseUtil from "@/firebase";

export default {
  props: ["cid", "picked"],
  data() {
    return {
      posts: false,
      order: "new",
    };
  },
  mounted() {
    firebaseUtil.getPost(this.cid).then((posts) => {
      this.posts = posts;
      console.log(this.posts);
    });
  },
  computed: {
    cdataWatch() {
      return this.cid;
    },
    orderWatch() {
      return this.order;
    },
    pickupWatch() {
      return this.picked;
    },
  },
  watch: {
    cdataWatch(data) {
      console.log(data);
      if (data && !this.posts) {
        firebaseUtil.getPost(data).then((posts) => {
          this.posts = posts;
          console.log(this.posts);
        });
      }
    },
    orderWatch(data) {
      if (data == "new") {
        this.posts.sort(function (a, b) {
          return (
            new Date(b.created.seconds * 1000).getTime() -
            new Date(a.created.seconds * 1000).getTime()
          );
        });
      } else if (data == "old") {
        this.posts.sort(function (a, b) {
          return (
            new Date(a.created.seconds * 1000).getTime() -
            new Date(b.created.seconds * 1000).getTime()
          );
        });
      }
    },
    pickupWatch() {
      this.loading = false;
    },
  },
  methods: {
    pickup(data, index) {
      index = this.order == "new" ? index + 1 : this.posts.length - index;
      data.index = index;
      this.$emit("pickup", data);
      console.log(data);
    },
    timeTransfer(unixTime) {
      var date = new Date(unixTime);
      return `${date.getUTCFullYear()}/${
        date.getUTCMonth() + 1
      }/${date.getUTCDate()}`;
    },
  },
};
</script>

<style lang="scss">
.challenge {
  &_content {
    @include Section_padding();
    .content {
      &_header {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        @include fz(16);
        .header {
          &_toggle {
            .toggle {
              margin: 10px;
              padding: 4px 16px;
              border: 1px solid #000;
              border-radius: 20px;
            }
          }
          &_select {
            select {
              padding: 4px 30px 4px 8px;
              border: 1px solid #000;
              border-radius: 4px;
            }
            label {
              position: relative;
            }
          }
        }
      }
      &_list {
        margin-top: 60px;
        width: calc(100% + 9.2vw);
        margin-left: -4.6vw;
        overflow: auto hidden;
        padding: 0 4.6vw;
        display: grid;
        grid-template-columns: repeat(auto-fit, 240px);
        grid-gap: 20px;
        .item {
          display: flex;
          flex-direction: column;
          position: relative;
          height: 0;
          padding-top: 100%;
          @include pc {
            max-width: 240px;
          }
          button {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
          }
          &_header {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            padding: 10px;
            @include zIndex(1);
            .index {
              @include fz(32);
              font-weight: 700;
              color: $main_orange;
              text-shadow: 4px 4px 6px #fff, -4px 4px 6px #fff,
                4px -4px 6px #fff, -4px -4px 6px #fff;
            }
            .date {
              @include fz(14);
              position: absolute;
              bottom: 10px;
              right: 10px;
              color: #fff;
              height: 30px;
              @include flex_c();
              padding: 0 10px;
              border-radius: 15px;
              background-color: $fade_color;
            }
          }
          &_main {
            position: absolute;
            top: 0;
            left: 0;
            background-color: #ddd;
            height: 100%;
            width: 100%;
          }
          &_sub {
            display: flex;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            > div {
              height: 0;
              padding-top: calc(100% / 3);
              width: calc(100% / 3);
              position: relative;
            }
          }
          &_img {
            img {
              @include pseudo(100%, 100%);
              top: 0;
              left: 0;
              background: #aaa;
              object-fit: cover;
            }
          }
        }
        @include sp {
          width: 104%;
          margin-left: -2%;
          margin-top: 0;
          padding: 20px 0;
          grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
          grid-gap: 0;
          .item {
            &_main {
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>